import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export interface SubmitCustomerRegistrationDTO {
  companyName: string;
  addressLine1: string;
  postalCode: string;
  city: string;
  country: string;
  purchaseAmt: number;
  currency: string;
  sector: string;
  taxId?: string;
  fullName: string;
  jobTitle: string;
  email: string;
  telephoneNumber?: string;
  whySchaeffler: string;
  yourCurrentSupplier: string;
  consent: boolean;
}

export const apiSubmitCustomerRegistration = (data: SubmitCustomerRegistrationDTO): Promise<Response> => {
  return occFetch(occUrl("/become-schaeffler-customer/submit"), {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  });
};
